//>>>>>>>>>>>>>>>>>>>>>>>>>Product Additional Images<<<<<<<<<<<<<<<<<<<<<<<<<
window.addEventListener('load', function() {
// Get the main product image element
const mainProductImg = document.getElementById('main-product-img');

// Get all small images
const smallImages = document.querySelectorAll('.small-img');

// Add click event listeners to each small image
smallImages.forEach((img) => {
  img.addEventListener('click', () => {
    // Update the src of the main product image to the clicked image's src
    mainProductImg.src = img.src;
  });
});


//>>>>>>>>>>>>>>>>>>>>>>>>>Bundle Selected Button<<<<<<<<<<<<<<<<<<<<<<<<<
// window.addEventListener('load', function() {
// // Get all bundle-info divs and buttons
// const bundles = document.querySelectorAll('.bundle-info');
// const buttons = document.querySelectorAll('.bundle-btn');
// const images = document.querySelectorAll('.bundle-img');
// console.log("buttons",buttons)
// // Initially hide all buttons and reset image heights
// buttons.forEach(button => button.style.display = 'none');
// images.forEach(image => image.style.height = '115px');
// if(buttons)
// // Set default selected bundle (2nd one)
// buttons[1].style.display = 'block';  // Show button for 2nd bundle
// images[1].style.height = '85px';      // Change width of 2nd bundle image

// // Add event listeners to each bundle
// bundles.forEach((bundle, index) => {
//   bundle.addEventListener('click', () => {
//     // Hide all buttons and reset image heights
//     buttons.forEach(button => button.style.display = 'none');
//     images.forEach(image => image.style.height = '115px');
//     console.log("bundle",bundle)

//     // Show the button and change image height for the selected bundle
//     buttons[index].style.display = 'block';
//     images[index].style.height = '85px';
//   });
// });
// })

//>>>>>>>>>>>>>>>>>>>>>>>>>Subscription Purchase Option<<<<<<<<<<<<<<<<<<<<<<<<<


 // // Get references to the radio buttons and the parent divs
 // const singlePurchaseRadio = document.getElementById('single');
 // const subPurchaseRadio = document.getElementById('sub');
 
 // const singlePurchaseDiv = document.querySelector('.single-pur');
 // const subPurchaseDiv = document.querySelector('.sub-pur');

 // // Function to apply selected styling
 // function updateSelection() {
 //   // Reset styles
 //   singlePurchaseDiv.classList.remove('selected');
 //   subPurchaseDiv.classList.remove('selected');

 //   // Apply 'selected' class to the parent div of the checked radio button
 //   if (singlePurchaseRadio.checked) {
 //     singlePurchaseDiv.classList.add('selected');
 //   }
 //   if (subPurchaseRadio.checked) {
 //     subPurchaseDiv.classList.add('selected');
 //   }
 // }

 // // Add event listeners for the radio buttons
 // singlePurchaseRadio.addEventListener('change', updateSelection);
 // subPurchaseRadio.addEventListener('change', updateSelection);

 // // Initial call to update the selection based on the default checked radio
 // updateSelection();


// //>>>>>>>>>>>>>>>>>>>>>>>>>Add/Less Counter Option<<<<<<<<<<<<<<<<<<<<<<<<<
// document.addEventListener('DOMContentLoaded', function () {
//   const countDisplay = document.querySelector('.count');
//   let count = 0;

//   document.querySelector('.plus').addEventListener('click', function () {
//     count++;
//     countDisplay.textContent = count;
//   });

//   document.querySelector('.minus').addEventListener('click', function () {
//     if (count > 0) {
//       count--;
//       countDisplay.textContent = count;
//     }
//   });
// });

//>>>>>>>>>>>>>>>>>>>>>>>>>Add/Less Counter Option<<<<<<<<<<<<<<<<<<<<<<<<<


  const tabs = document.querySelectorAll('.tab-btn');
  const tabPanes = document.querySelectorAll('.tab-pane');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = tab.getAttribute('data-tab');

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('active'));

      // Add active class to clicked tab
      tab.classList.add('active');

      // Hide all tab panes
      tabPanes.forEach(pane => pane.classList.remove('active'));

      // Show the clicked tab pane
      document.getElementById(targetTab).classList.add('active');
    });
  });



//>>>>>>>>>>>>>>>>>>>>>>>>>Swiper Option<<<<<<<<<<<<<<<<<<<<<<<<<


//  const swiper = new Swiper('.swiper', {
//   // Optional parameters
//   direction: 'horizontal',
//   loop: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
   
// });

//>>>>>>>>>>>>>>>>>>>>>>>>>Accordion Code<<<<<<<<<<<<<<<<<<<<<<<<<



var acc = document.getElementsByClassName("accordion");
for (var i = 0; i < acc.length; i++) {
  // console.log("acc",acc)
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}})